<template>
  <div class="home">
    <!-- <template v-if="loadComplete == false">
      <div class="loader"></div>
    </template> -->
    <template>
      <div id="loaderClass" class="loaderSection">
        <div class="loader"></div>
        <h2 class="loading">Loading...</h2>
      </div>
      <div id="table" v-if="loadFirst == true">
        <TableHome
          :Year="season"
          :courseCode="course"
          :TourName="useName"
          :TourLogo="tourlogo"
          :bkImage="bkImage"
          :currentReport="reportTitle"
          :reportURL="currentReport"
          :live="tm_params.live_scoring"
          :config="config"
          :match="tm_params.match_play"
          :currentTitle='currentTitle'
          :roundsPLayed='roundsPLayed'
          :imageCode='imageCode'
          :tournDates="tournDates"
          :imagefiles="imagefiles"
          :course_name="course_name"
          :courseDates="courseDates"
          :live_scoring="live_scoring"
          :mobName="mobName"
          :cptAll="cptAll"
          :cp2All="cp2All"
          :cp3All="cp3All"
          :pamAll="pamAll"
          :porAll="porAll"
          :qscAll="qscAll"
          :showcptreports="showcptreports"
          :showcp2reports="showcp2reports"
          :showcp3reports="showcp3reports"
          :showpamreports="showpamreports"
          :showporreports="showporreports"
          :showqscreports="showqscreports"
          :Stableford="Stableford"
          :qscshowTourn="qscshowTourn"
          :pamshowTourn="pamshowTourn"
          :porshowTourn="porshowTourn"
          :cp2showTourn="cp2showTourn"
          :cp3showTourn="cp3showTourn"
          :cptshowTourn="cptshowTourn"
        />
      </div>
      <b-container class="nocon" v-if="showbutton && tourSelect.CPT == 'Y'">
        <template>
          <div class="votePlayerofMonth">
            <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
              <template v-if="pollappImage != ''">
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <img
                      class="appImage pulse"
                      :src="pollappImage"
                      loading="lazy"
                      decoding="async"
                    >
                  </b-link>
                </template>
                <template v-else>
                  <img
                    class="appImage pulse"
                    v-b-modal.modal-xl
                    :src="pollappImage"
                    loading="lazy"
                    decoding="async"
                  >  
                </template>
              </template>
              <template v-else>
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <b-button variant="success" class="pulse"> Vote for Player of the Month</b-button>
                  </b-link>
                </template>
                <template v-else>
                  <b-button v-b-modal.modal-xl variant="success" class="pulse"> Vote for Player of the Month</b-button>
                </template>
              </template>
            </template>
          </div>
        </template>
      </b-container>

      <!-- Polls Section to test -->

       <b-modal id="modal-xl" size="xl" >
          <b-container>
            <div v-for="(box, index) in Extradata" :key="'mod' +index">
              <template v-if="thankyouMessage == 'N'">
                <div >
                  <b-row>
                    <b-col lg="6" sm="12">
                      <template v-if="box.website_video_url !== ''">
                        <template v-if="box.website_video_auto == 'Y'">
                          <iframe allowfullscreen aspect="16by9" muted playsinline allow='autoplay' :src="box.website_video_url + '&autoplay=1'" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <template v-else>
                          <iframe allowfullscreen aspect="16by9" muted playsinline :src="box.website_video_url" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <!-- <b-embed
                          type="iframe"
                          aspect="16by9"
                          :src="box.website_video_url"
                          allowfullscreen
                        ></b-embed> -->
                      </template>
                      <template v-else-if="box.website_image != ''">
                        <img
                          v-if="box.website_image != ''"
                          class="votePicture"
                          :src="box.website_image"
                          loading="lazy"
                          decoding="async"
                        >
                      </template>
                      <b-modal id="modal-1" title="Terms and Conditions" style="height: 600px; overflow: scroll;">
                        <h3 class="my-4 termsTitle" v-html="docTitle"></h3>
                        <p class="my-4 termsContent" v-html="docContent"></p>
                      </b-modal>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <form class="formSection" ref="formdata">
                        <b-row>
                          <b-col lg="12" sm="12">
                            <p class="boxFull" v-if="box.full_desc != ''" v-html="box.full_desc"></p>
                          </b-col>
                          <!-- <b-col lg="6" sm="12">
                            <p class="boxexpiry" v-if="box.end_date != '' && box.end_time != ''" > Vote expiry date: {{box.end_date}} - {{box.end_time}} ({{timeZone}})</p>
                          </b-col> -->
                        </b-row>
                        <template v-if="box.anonymous == 'N'">
                          <b-row>
                            <b-col lg="5" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polfirstName"
                                  type="name"
                                  placeholder="Enter First Name"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polSurname"
                                  type="name"
                                  placeholder="Enter Surname"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <div class="extraPadTop">
                                <b-form-checkbox
                                  id="checkbox-2"
                                  v-model="terms"
                                  name="checkbox-2"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                                >
                                  I accept the <span class="termsandCon" @click="getTermsConditions" v-b-modal.modal-1>terms and conditions</span>
                                </b-form-checkbox>

                                <!-- <div>State: <strong>{{ terms }}</strong></div> -->
                              </div>
                              <!-- <div class="joinFanzon" v-if="box.askfanzone == 'Y'">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="fanZonejoin"
                                  name="checkbox-1"
                                  value="Y"
                                  unchecked-value="N"
                                >
                                Join Fanzon
                                </b-form-checkbox>

                              </div> -->
                              <div class="deskHide">
                                <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                                <b-row>
                                  <b-col cols="6" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                    <lable v-if="box.multi_select == 'N'">
                                      <span class="titlesCol">
                                        Select one below
                                      </span>
                                    </lable>
                                    <lable v-else>
                                      <span class="titlesCol">
                                        Select one or more below
                                      </span>
                                    </lable>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showvotes == 'Y'">
                                    <span class="titlesCol votes">
                                      Votes
                                    </span>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showpercent == 'Y'">
                                    <span class="titlesCol perc">
                                      %
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                  <b-row>
                                    <template v-if="box.multi_select == 'N'">
                                      <b-col lg="12" sm="12" v-for="(op, index) in box.opts.opts_entry" :key="'op' + index">
                                        <b-row>
                                          <b-col cols="6" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                              {{op.desc}}
                                            </b-form-radio>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span>{{op.percent}}</span>
                                            </template>
                                          </b-col>
                                        </b-row>
                                      </b-col>
                                    </template>
                                    <template v-else>
                                      <b-col lg="12" sm="12">
                                        <div v-for="(op, index) in box.opts.opts_entry" :key="'anotherop'+ index">
                                        <b-row>
                                          <b-col :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="op.desc">{{op.desc}}</label>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span class="percent">{{op.percent}}</span>
                                            </template>                                            
                                          </b-col>
                                        </b-row>
                                        </div>
                                      </b-col>
                                    </template>
                                  </b-row>
                                </b-form-group>
                              </div>
                              <!-- <div class="mt-3">Selected: <strong>{{ Polselected + 1 }}</strong></div> -->
                              <template v-if="polEmail !== '' && polEmail.includes('@') && polfirstName !== '' && polSurname !== '' && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                            <b-col lg="7" sm="12" class="mobHide">
                              <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                              <b-row>
                                <b-col lg="8" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                  <lable v-if="box.multi_select == 'N'">
                                    <span class="titlesCol">
                                      Select one below
                                    </span>
                                  </lable>
                                  <lable v-else>
                                    <span class="titlesCol">
                                      Select one or more below
                                    </span>
                                  </lable>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showvotes == 'Y'">
                                  <span class="titlesCol votes">
                                    Votes
                                  </span>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showpercent == 'Y'">
                                  <span class="titlesCol perc">
                                    %
                                  </span>
                                </b-col>
                              </b-row>
                              <b-form-group label="" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="'boxop' +index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="'boxentryop' + index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col lg="12" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group label="Select one below" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="'secodnboxentry' + index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="'entryopthird' + index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                              <template v-if="polEmail !== '' && polEmail.includes('@') && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                      </form>
                    </b-col>
                  </b-row>
                </div>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="6" sm="12">
                    <img
                      v-if="box.website_image != ''"
                      class="votePicture"
                      :src="box.website_image"
                      loading="lazy"
                      decoding="async"
                    >
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="voteData.status == 'FAIL'">
                      <h2 class="thankyou" v-html="voteData.message"></h2>
                    </template>
                    <template v-else>
                      <h2 class="thankyou">Thank you for your Vote</h2>
                    </template>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-container>
        </b-modal>

      <!-- End of Polls Section to test -->  
      <div
        id="pathway-section"
        class="darkBkcolor lazy-section"
      >
        <Pathway
          v-if="loadSecond"
          :Year="tm_params.tm_params.season_code"
          :config="config"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
        />
      </div>
      <div
        id="pathway-incentive-section"
        class="darkBkcolor lazy-section"
      >
        <PathwayIncentive
          v-if="loadPathwayIncentive"
          :Year="tm_params.tm_params.season_code"
          :config="config"
          :DEFIMAGESAMS3="DEFIMAGESAMS3"
        />
      </div>
      <div id="posts"
        class="lazy-section"
        v-if="loadThird">
        <b-container class="homeCont">
          <Posts :config="config"/>
        </b-container>
      </div>
      <div
        id="oom-slider"
        class="lazy-section"
      >
        <OOMslider
          v-if="loadFourth"
          :config="config"
          :Year="season"
        />
      </div>
      <div
        id="youtube-section"
        class="messageSec youPad lazy-section"
      >
        <b-container v-if="loadYoutube">
          <Youtube :config="config" />
        </b-container>
      </div>
      <div
        id="message-section"
        class="lazy-section"
      >
        <Message
          v-if="loadFifth"
          :config="config"
        />
      </div>
      <div
        id="download-section"
        class="lazy-section"
      >
        <Download
          v-if="loadSixth"
          :config="config"
        />
      </div>
      <div class="liveScoreMsg" v-if="tm_params.live_message === 'Y'">
        <h3 class="liveMsg">
          {{ tm_params.live_scoring_mess }}
        </h3>
      </div>
    </template>
  </div>
</template>

<script>
import TableHome from "@/components/tableHome.vue";

const Pathway = () => import("@/components/pathway.vue");
const PathwayIncentive = () => import("@/components/pathwayIncentives.vue");
const OOMslider = () => import("@/components/oomSlider.vue");
const Posts = () => import("@/components/posts.vue");
const Message = () => import("@/components/message.vue");
const Youtube = () => import("@/components/youTube.vue");
const Download = () => import("@/components/download.vue");

import apiCall from "@/services/api";
import axios from "axios";
import * as CryptoJS from "crypto-js";
export default {
  name: "home",
  props: ["config", "meta_data"],
  components: {
    TableHome,
    Pathway,
    OOMslider,
    Posts,
    Message,
    Download,
    Youtube,
    PathwayIncentive
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      lazyObservers: [],
      cryptoAES: CryptoJSAesJson,
      course_name:'',
      courseDates:'',
      live_scoring:'',
      mobName:'',
      tm_params: [],
      reports: [],
      course: [],
      season: [],
      roundsPLayed: '',
      imageCode: '',
      tournDates: '',
      imagefiles: [],
      pollData:[],
      polEmail: '',
      polfirstName: '',
      polSurname:'',
      Polselected: '',
      selectedPol:[],
      MultiPolselected: [],
      showbutton: '',
      timeZone: '',
      selectedItems: [],
      showbuttonExtra: [],
      appImage: '',
      // fanZonejoin: 'Y',
      thankyouMessage: 'N',
      voteData: {},
      terms: '',
      docTitle: '',
      docContent:'',
      pollsource: '',
      pollgeneral: '',
      pollMselect: '',
      pollappImage: '',
      pollType: '',
      pollTypeLink: '',
      Extradata: [],
      tourSelect: '',
      useName: '',
      tourlogo: '',
      bkImage: '',
      sponPDF: '',
      tournID: 'cpt',
      cptAll:[],
      cp2All:[],
      cp3All:[],
      pamAll:[],
      porAll:[],
      qscAll:[],
      loadComplete: false,
      loadFirst:false,
      loadSecond:false,
      loadThird:false,
      loadFourth:false,
      loadFifth:false,
      loadSixth:false,
      loadYoutube:false,
      loadPathwayIncentive:false,
      tournIDcp2: [],
      tournIDpor: [],
      coursecp2: [],
      coursepor: [],
      showcptreports: '',
      showcp2reports: '',
      showcp3reports: '',
      showpamreports: '',
      showqscreports: '',
      showporreports: '',
      Stableford: '',
      porshowTourn: '',
      qscshowTourn: '',
      pamshowTourn: '',
      cp2showTourn: '',
      cp3showTourn: '',
      cptshowTourn: ''
    };
  },
  // metaInfo() {
  //   var metaD = this.metaSelect[0].yoast_meta
  //   return {
  //     title: 'cpts Tour Golf – Rising Golf Stars',
  //     meta: metaD
  //   };
  // },
  computed: {
    metaSelect: function() {
      return this.meta_data.filter((page) => page.slug === this.$route.name);
    },
    filterReports: function() {
        if (Array.isArray(this.reports)) {
          return this.reports.filter(
            (reports_entry) =>
              reports_entry.report_title.includes("Tournament Entries") ||
              reports_entry.report_title.includes("Score") ||
              // reports_entry.report_title.includes("Live") ||
              reports_entry.report_title.includes("Final")
          );
        } else return this.reports; 
    },
    currentReport: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_url;
      else return this.filterReports.report_url;
    },
    currentTitle: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_title;
      else return this.filterReports.report_title;
    },
    reportTitle: function(url) {
      if ( this.currentReport !== undefined) {
          if (
            this.currentReport.indexOf("tmentry") !== -1
          ) {
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-entryw-entries.json?randomadd=" +
              new Date().getTime();
          } else if(this.currentReport.indexOf("tmentry") !== -1) {
          url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
            "-entry-entries.json?randomadd=" +
            new Date().getTime();
          } else if(this.currentReport.indexOf("tmdraw") !== -1) {
            var subRep = this.currentReport.lastIndexOf("round=") + 6;
            var indNext = this.currentReport.indexOf("~", subRep);
            var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
            url =
              this.config.VUE_APP_API +
              this.config.VUE_APP_ID +
              "/cache/" +
              this.tournID +
              "/" +
              this.season +
              "/" +
              this.season +
              "-" +
              this.course +
              "-" +
              "draw" +
              "-" +
              'R'+drawRnd
              +
              "-draw.json?randomadd=" +
              new Date().getTime();
          } else {
            if (this.currentReport.indexOf("tmscore") !== -1) {
              var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
              var indNext2 = this.currentReport.indexOf("~", subRep2);
              var repParams = this.currentReport.substr(
                subRep2,
                indNext2 - subRep2
              );
              if (repParams && repParams.indexOf(".cgi") < 0) {
                url =
                  this.config.VUE_APP_API +
                  this.config.VUE_APP_ID +
                  "/cache/" +
                  this.tournID +
                  "/" +
                  this.season +
                  "/" +
                  this.season +
                  "-" +
                  this.course +
                  "-scores-" +
                  repParams +
                  ".json" +
                  "?randomadd=" +
                  new Date().getTime();
              } else {
                url =
                  this.config.VUE_APP_API +
                  this.config.VUE_APP_ID +
                  "/cache/" +
                  this.tournID +
                  "/" +
                  this.season +
                  "/" +
                  this.season +
                  "-" +
                  this.course +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
              {
                url =
                  this.config.VUE_APP_API +
                  this.config.VUE_APP_ID +
                  "/cache/" +
                  this.tournID +
                  "/" +
                  this.season +
                  "/" +
                  this.season +
                  "-" +
                  this.course +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmstats") !== -1) {
              {
                url =
                  this.config.VUE_APP_API +
                  this.config.VUE_APP_ID +
                  "/cache/" +
                  this.tournID +
                  "/" +
                  this.season +
                  "/" +
                  this.season +
                  "-" +
                  this.course +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmcrsts") !== -1) {
              {
                url =
                  this.config.VUE_APP_API +
                  this.config.VUE_APP_ID +
                  "/cache/" +
                  this.tournID +
                  "/" +
                  this.season +
                  "/" +
                  this.season +
                  "-" +
                  this.course +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmresult") !== -1) {
              var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
              var indNext1 = this.currentReport.indexOf("~", subRep1);
              var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
              console.log("resNum === ");
              console.log(resNum1);
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-result-result-" +
                resNum1 +
                ".json" +
                "?randomadd=" +
                new Date().getTime();
            } else {
              url =
                this.config.VUE_APP_API +
                this.config.VUE_APP_ID +
                "/cache/" +
                this.tournID +
                "/" +
                this.season +
                "/" +
                this.season +
                "-" +
                this.course +
                "-result-result-PF.json" +
                "?randomadd=" +
                new Date().getTime();
            }
          }         
      } else {
        console.log('error')
      }
      return url;
    },
  },
  methods: {
    setupLazyLoading() {
      // Fallback for older browsers
      if (!("IntersectionObserver" in window)) {
        this.loadSecond = true;
        this.loadPathwayIncentive = true;
        this.loadThird = true;
        this.loadFourth = true;
        this.loadFifth = true;
        this.loadYoutube = true;
        this.loadSixth = true;

        return;
      }

      const sections = [
        {
          id: "pathway-section",
          load: () => {
            this.loadSecond = true;
          }
        },
        {
          id: "pathway-incentive-section",
          load: () => {
            this.loadPathwayIncentive = true;
          }
        },
        {
          id: "posts",
          load: () => {
            this.loadThird = true;
          }
        },
        {
          id: "oom-slider",
          load: () => {
            this.loadFourth = true;
          }
        },
        {
          id: "youtube-section",
          load: () => {
            this.loadYoutube = true;
          }
        },
        {
          id: "message-section",
          load: () => {
            this.loadFifth = true;
          }
        },
        {
          id: "download-section",
          load: () => {
            this.loadSixth = true;
          }
        }
      ];

      sections.forEach(section => {
        const element = document.getElementById(section.id);

        if (!element) {
          return;
        }

        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {

              if (!entry.isIntersecting) {
                return;
              }

              // Start loading the component
              section.load();

              // We only need to detect this section once
              observer.disconnect();

              this.lazyObservers =
                this.lazyObservers.filter(
                  item => item !== observer
                );
            });
          },
          {
            // Start loading 500px before the user reaches it
            rootMargin: "500px 0px",
            threshold: 0
          }
        );

        observer.observe(element);

        this.lazyObservers.push(observer);
      });
    },
    // Get all tours data below
    getcp2tour: function() {
      axios //add API Call
      .get(
          'https://api.euro.ocs-software.com/cpt/cache/cp2/tmticx?randomaddText=' +
            new Date().getTime()
      )
      .then(({ data }) => {
          this.cp2 = data;
          this.tournID2 = 'cp2';
          this.course2 = this.cp2.code;
          if (this.cp2.reports == '') {
            this.showcp2reports = 'N'
          } else {
            this.showcp2reports = 'Y'
          }
          if (this.cp2.days_away > -6 && this.cp2.days_away < 4) {
            this.cp2showTourn = true;
            console.log('in true')
          } else {
            this.cp2showTourn = false;
            console.log('in false')
          }
          if (this.cp2.reports != '') {
            if (Array.isArray(this.cp2.reports.reports_entry)) {
              this.cp2.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.report = element.report_url;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(element.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep3 = element.report_url.lastIndexOf("params=") + 7;
                  var indNext3 = element.report_url.indexOf("~", subRep3);
                  var repParams1 = element.report_url.substr(
                    subRep3,
                    indNext3 - subRep3
                  );
                  if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                   this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      // this.course +
                      this.course2 +
                      "-scores-" +
                      repParams1 +
                      ".json" +
                      "?randomadd=" +
                      new Date().getTime();
                  } else {
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                  }
                } else if (element.report_url.indexOf("tmlsmon") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep1 = element.report_url.lastIndexOf("result=") + 7;
                  var indNext1 = element.report_url.indexOf("~", subRep1);
                  var resNum1 = element.report_url.substr(subRep1, indNext1 - subRep1);
                  console.log("resNum === ");
                  console.log(resNum1);
                  this.url =
                    this.config.VUE_APP_API +
                    this.config.VUE_APP_ID +
                    "/cache/" +
                    this.tournID2 +
                    "/" +
                    this.season +
                    "/" +
                    this.season +
                    "-" +
                    this.course2 +
                    "-result-result-" +
                    resNum1 +
                    ".json" +
                    "?randomadd=" +
                    new Date().getTime();
                } else if(element.report_url.indexOf("tmresult") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                      "-result-result-PF.json" +
                      "?randomadd=" +
                      new Date().getTime();
                }
              });
            } else {
              if (this.cp2.reports.reports_entry.report_url.indexOf("tmentry") !== -1) {
                this.report = this.cp2.reports.reports_entry.report_url;
                this.reportTitleElement = this.cp2.reports.reports_entry.report_title
                if (this.report.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.cp2.reports.reports_entry.report_title;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(this.report.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.cp2.reports.reports_entry.report_url;
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID2 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course2 +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
              }
              console.log("this.url")
              console.log(this.url)
            }
          }
          const cp2All = []
          if (this.cp2.reports == '') {
            console.log('NoPush')
            // cp2All.push({ "code": this.cp2.code, "name": this.cp2.full_name, "reports": 'N', "repName":  "", "num": 'Tier 2', 'bkcolor': '#bde9d8', "tour": "cp2", "color": "#081C3F" })
            // this.cp2All = cp2All
          } else {
            cp2All.push({ "code": this.cp2.code, "manyRounds": this.cp2.rounds, "daysAway": this.cp2.days_away, "name": this.cp2.full_name, "reports": this.url, "repName":  this.reportTitleElement, "repURL": this.reportURLLink, "num": 'Tier 2', 'bkcolor': '#bde9d8', "tour": "cp2", "color": "#081C3F" })
            this.cp2All = cp2All 
          }
      });
    },
    getcp3tour: function() {
      axios //add API Call
      .get(
          'https://api.euro.ocs-software.com/cpt/cache/cp3/tmticx?randomaddText=' +
            new Date().getTime()
      )
      .then(({ data }) => {
          this.cp3 = data;
          console.log("this.cp3")
          console.log(this.cp3)
          this.tournID3 = 'cp3';
          this.course3 = this.cp3.code;
          if (this.cp3.reports == '') {
            this.showcp3reports = 'N'
          } else {
            this.showcp3reports = 'Y'
          }
          if (this.cp3.days_away > -6 && this.cp3.days_away < 4) {
            this.cp3showTourn = true;
            console.log('in true')
          } else {
            this.cp3showTourn = false;
            console.log('in false')
          }
          if (this.cp3.reports != "") {
            if (Array.isArray(this.cp3.reports.reports_entry)) {
              this.cp3.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.report = element.report_url;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(element.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep3 = element.report_url.lastIndexOf("params=") + 7;
                  var indNext3 = element.report_url.indexOf("~", subRep3);
                  var repParams1 = element.report_url.substr(
                    subRep3,
                    indNext3 - subRep3
                  );
                  if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                   this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      // this.course +
                      this.course3 +
                      "-scores-" +
                      repParams1 +
                      ".json" +
                      "?randomadd=" +
                      new Date().getTime();
                  } else {
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                  }
                } else if (element.report_url.indexOf("tmlsmon") !== -1) {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep1 = element.report_url.lastIndexOf("result=") + 7;
                  var indNext1 = element.report_url.indexOf("~", subRep1);
                  var resNum1 = element.report_url.substr(subRep1, indNext1 - subRep1);
                  console.log("resNum === ");
                  console.log(resNum1);
                  this.url =
                    this.config.VUE_APP_API +
                    this.config.VUE_APP_ID +
                    "/cache/" +
                    this.tournID3 +
                    "/" +
                    this.season +
                    "/" +
                    this.season +
                    "-" +
                    this.course3 +
                    "-result-result-" +
                    resNum1 +
                    ".json" +
                    "?randomadd=" +
                    new Date().getTime();
                } else if (element.report_url.indexOf("tmresult") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                      "-result-result-PF.json" +
                      "?randomadd=" +
                      new Date().getTime();
                }
              });
            } else {
              if (this.cp3.reports.reports_entry.report_url.indexOf("tmentry") !== -1) {
                this.reportTitleElement = this.cp3.reports.reports_entry.report_title;
                this.report = this.cp3.reports.reports_entry.report_url;
                if (this.report.indexOf("tmentry") !== -1) {
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(this.report.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.cp3.reports.reports_entry.report_title;
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournID3 +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.course3 +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
              }
              console.log("this.url")
              console.log(this.url)
            }}
          const cp3All = []
          // cp3All.push({ "code": this.cp3.code, "name": this.cp3.full_name, "reports": this.url, "repName":  this.reportTitleElement, "num": 'Amateur', 'bkcolor': '#dfc3c2', "tour": "cp3", "color": "#fff"})
          if (this.cp3.reports == '') {
            console.log('NoPush')
            // cp3All.push({ "code": this.cp3.code, "name": this.cp3.full_name, "reports": 'N', "repName":  "", "num": 'Amateur', 'bkcolor': '#dfc3c2', "tour": "cp3", "color": "#fff" })
            // this.cp3All = cp3All
          } else {
            if (Array.isArray(this.cp3.reports.reports_entry)) {
              cp3All.push({ "code": this.cp3.code, "manyRounds": this.cp3.rounds, "daysAway": this.cp3.days_away, "name": this.cp3.full_name, "reports": this.url, "repName":  this.reportTitleElement, "repURL": this.reportURLLink, "num": 'Amateur', 'bkcolor': '#dfc3c2', "tour": "cp3", "color": "#fff" })
              this.cp3All = cp3All 
            } else if (this.reportTitleElement == 'Tournament Entries') {
              cp3All.push({ "code": this.cp3.code, "manyRounds": this.cp3.rounds, "name": this.cp3.full_name, "reports": this.url, "repName":  this.reportTitleElement, "num": 'Amateur', 'bkcolor': '#dfc3c2', "tour": "cp3", "color": "#fff" })
              this.cp3All = cp3All
            }
          }
      });
    },
    getpamtour: function() {
      axios //add API Call
      .get(
          'https://api.euro.ocs-software.com/cpt/cache/pam/tmticx?randomaddText=' +
            new Date().getTime()
      )
      .then(({ data }) => {
          this.pam = data;
          this.tournIDpam = 'pam';
          this.coursepam = this.pam.code;
          if (this.pam.reports == '') {
            this.showpamreports = 'N'
          } else {
            this.showpamreports = 'Y'
          }
          if (this.pam.days_away > -6 && this.pam.days_away < 4) {
            this.pamshowTourn = true;
            console.log('in true')
          } else {
            this.pamshowTourn = false;
            console.log('in false')
          }
          if (this.pam.reports != "") {
            if (Array.isArray(this.pam.reports.reports_entry)) {
              this.pam.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.report = element.report_url;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(element.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep3 = element.report_url.lastIndexOf("params=") + 7;
                  var indNext3 = element.report_url.indexOf("~", subRep3);
                  var repParams1 = element.report_url.substr(
                    subRep3,
                    indNext3 - subRep3
                  );
                  if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                   this.reportTitleElement = element.report_title
                   this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      // this.course +
                      this.coursepam +
                      "-scores-" +
                      repParams1 +
                      ".json" +
                      "?randomadd=" +
                      new Date().getTime();
                  } else {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                  }
                } else if (element.report_url.indexOf("tmlsmon") !== -1) {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep1 = element.report_url.lastIndexOf("result=") + 7;
                  var indNext1 = element.report_url.indexOf("~", subRep1);
                  var resNum1 = element.report_url.substr(subRep1, indNext1 - subRep1);
                  console.log("resNum === ");
                  console.log(resNum1);
                  this.url =
                    this.config.VUE_APP_API +
                    this.config.VUE_APP_ID +
                    "/cache/" +
                    this.tournIDpam +
                    "/" +
                    this.season +
                    "/" +
                    this.season +
                    "-" +
                    this.coursepam +
                    "-result-result-" +
                    resNum1 +
                    ".json" +
                    "?randomadd=" +
                    new Date().getTime();
                } else if (element.report_url.indexOf("tmresult") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                      "-result-result-PF.json" +
                      "?randomadd=" +
                      new Date().getTime();
                }
              });
            } else {
              if (this.pam.reports.reports_entry.report_url.indexOf("tmentry") !== -1) {
                this.reportTitleElement = this.pam.reports.reports_entry.report_title
                this.report = this.pam.reports.reports_entry.report_url;
                if (this.report.indexOf("tmentry") !== -1) {
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(this.report.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.pam.reports.reports_entry.report_title
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepam +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
              }
              console.log("this.url")
              console.log(this.url)
            }}
          const pamAll = []
          if (this.pam.reports == '') {
            console.log('NoPush')
            // pamAll.push({ "code": this.pam.code, "name": this.pam.full_name, "reports": "N", "repName":  "", "num": 'Pro-Ams', 'bkcolor': '#fff', "tour": "pam", "color": "#081C3F" })
            // this.pamAll = pamAll
          } else {
            pamAll.push({ "code": this.pam.code, "manyRounds": this.pam.rounds, "daysAway": this.pam.days_away, "name": this.pam.full_name, "reports": this.url, "repName":  this.reportTitleElement, "repURL": this.reportURLLink, "num": 'Pro-Ams', 'bkcolor': '#c3bcce', "tour": "pam", "color": "#081C3F" })
            this.pamAll = pamAll
          }
      });
    },
    getportour: function() {
      axios //add API Call
      .get(
          'https://api.euro.ocs-software.com/cpt/cache/por/tmticx?randomaddText=' +
            new Date().getTime()
      )
      .then(({ data }) => {
          this.por = data;
          this.tournIDpam = 'por';
          this.coursepor = this.por.code;
          if (this.pam.reports == '') {
            this.showporreports = 'N'
          } else {
            this.showporreports = 'Y'
          }
          if (this.por.days_away > -6 && this.por.days_away < 4) {
            this.porshowTourn = true;
            console.log('in true')
          } else {
            this.porshowTourn = false;
            console.log('in false')
          }
          if (this.por.reports != "") {
            if (Array.isArray(this.por.reports.reports_entry)) {
              this.por.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.report = element.report_url;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(element.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep3 = element.report_url.lastIndexOf("params=") + 7;
                  var indNext3 = element.report_url.indexOf("~", subRep3);
                  var repParams1 = element.report_url.substr(
                    subRep3,
                    indNext3 - subRep3
                  );
                  if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                   this.reportTitleElement = element.report_title
                   this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      // this.course +
                      this.coursepor +
                      "-scores-" +
                      repParams1 +
                      ".json" +
                      "?randomadd=" +
                      new Date().getTime();
                  } else {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                  }
                } else if (element.report_url.indexOf("tmlsmon") !== -1) {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep1 = element.report_url.lastIndexOf("result=") + 7;
                  var indNext1 = element.report_url.indexOf("~", subRep1);
                  var resNum1 = element.report_url.substr(subRep1, indNext1 - subRep1);
                  console.log("resNum === ");
                  console.log(resNum1);
                  this.url =
                    this.config.VUE_APP_API +
                    this.config.VUE_APP_ID +
                    "/cache/" +
                    this.tournIDpor +
                    "/" +
                    this.season +
                    "/" +
                    this.season +
                    "-" +
                    this.coursepor +
                    "-result-result-" +
                    resNum1 +
                    ".json" +
                    "?randomadd=" +
                    new Date().getTime();
                } else if (element.report_url.indexOf("tmresult") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                      "-result-result-PF.json" +
                      "?randomadd=" +
                      new Date().getTime();
                }
              });
            } else {
              if (this.por.reports.reports_entry.report_url.indexOf("tmentry") !== -1) {
                this.reportTitleElement = this.por.reports.reports_entry.report_title
                this.report = this.por.reports.reports_entry.report_url;
                if (this.report.indexOf("tmentry") !== -1) {
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(this.report.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.por.reports.reports_entry.report_title
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpor+
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.coursepor +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
              }
              console.log("this.url")
              console.log(this.url)
            }}
          const porAll = []
          if (this.por.reports == '') {
            console.log('NoPush')
            // pamAll.push({ "code": this.pam.code, "name": this.pam.full_name, "reports": "N", "repName":  "", "num": 'Pro-Ams', 'bkcolor': '#fff', "tour": "pam", "color": "#081C3F" })
            // this.pamAll = pamAll
          } else {
            porAll.push({ "code": this.por.code, "manyRounds": this.por.rounds, "daysAway": this.por.days_away, "name": this.por.full_name, "reports": this.url, "repName":  this.reportTitleElement, "repURL": this.reportURLLink, "num": 'Portugal Series', 'bkcolor': '#c96b6b', "tour": "por", "color": "#fff" })
            this.porAll = porAll
          }
      });
    },
    getqsctour: function() {
      axios //add API Call
      .get(
          'https://api.euro.ocs-software.com/cpt/cache/qsc/tmticx?randomaddText=' +
            new Date().getTime()
      )
      .then(({ data }) => {
          this.qsc = data;
          console.log("this.qsc")
          console.log(this.qsc)
          this.tournIDqsc = 'qsc';
          this.courseqsc = this.qsc.code;
          if (this.qsc.reports == '') {
            this.showqscreports = 'N'
          } else {
            this.showqscreports = 'Y'
          }
          if (this.qsc.days_away > -6 && this.qsc.days_away < 4) {
            this.qscshowTourn = true;
            console.log('in true')
          } else {
            this.qscshowTourn = false;
            console.log('in false')
          }
          if (this.qsc.reports != "") {
            if (Array.isArray(this.qsc.reports.reports_entry)) {
              this.qsc.reports.reports_entry.forEach(element => {
                if (element.report_url.indexOf("tmentry") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.report = element.report_url;
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(element.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
                if (element.report_url.indexOf("tmscore") !== -1) {
                  console.log('score in')
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep3 = element.report_url.lastIndexOf("params=") + 7;
                  var indNext3 = element.report_url.indexOf("~", subRep3);
                  var repParams1 = element.report_url.substr(
                    subRep3,
                    indNext3 - subRep3
                  );
                  if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                   this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      // this.course +
                      this.courseqsc +
                      "-scores-" +
                      repParams1 +
                      ".json" +
                      "?randomadd=" +
                      new Date().getTime();
                  } else {
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                  }
                } else if (element.report_url.indexOf("tmlsmon") !== -1) {
                      this.reportTitleElement = element.report_title
                      this.reportURLLink = element.report_url
                      this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                      "-scores-latest.json" +
                      "?gt=y&randomadd=" +
                      new Date().getTime();
                }
                if (element.report_url.indexOf("tmresult") !== -1) {
                  this.reportTitleElement = element.report_title
                  this.reportURLLink = element.report_url
                  var subRep1 = element.report_url.lastIndexOf("result=") + 7;
                  var indNext1 = element.report_url.indexOf("~", subRep1);
                  var resNum1 = element.report_url.substr(subRep1, indNext1 - subRep1);
                  console.log("resNum === ");
                  console.log(resNum1);
                  this.url =
                    this.config.VUE_APP_API +
                    this.config.VUE_APP_ID +
                    "/cache/" +
                    this.tournIDqsc +
                    "/" +
                    this.season +
                    "/" +
                    this.season +
                    "-" +
                    this.courseqsc +
                    "-result-result-" +
                    resNum1 +
                    ".json" +
                    "?randomadd=" +
                    new Date().getTime();
                } else if (element.report_url.indexOf("tmresult") !== -1) {
                    this.reportTitleElement = element.report_title
                    this.reportURLLink = element.report_url
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDpam +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqscs +
                      "-result-result-PF.json" +
                      "?randomadd=" +
                      new Date().getTime();
                }
              });
            } else {
              if (this.qsc.reports.reports_entry.report_url.indexOf("tmentry") !== -1) {
                this.reportTitleElement = this.qsc.reports.reports_entry.report_title
                this.report = this.qsc.reports.reports_entry.report_url;
                if (this.report.indexOf("tmentry") !== -1) {
                    this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                      "-entryw-entries.json?randomadd=" +
                      new Date().getTime();
                  } else if(this.report.report_url.indexOf("tmentry") !== -1) {
                  this.reportTitleElement = this.qsc.reports.reports_entry.report_title
                  this.url =
                      this.config.VUE_APP_API +
                      this.config.VUE_APP_ID +
                      "/cache/" +
                      this.tournIDqsc +
                      "/" +
                      this.season +
                      "/" +
                      this.season +
                      "-" +
                      this.courseqsc +
                    "-entry-entries.json?randomadd=" +
                    new Date().getTime();
                }
              }
              console.log("this.url")
              console.log(this.url)
            }}
          const qscAll = []
          if (this.qsc.reports == '') {
            console.log('NoPush')
            // qscAll.push({ "code": this.qsc.code, "name": this.qsc.full_name, "reports": "N", "repName":  "", "num": 'Q-School', 'bkcolor': '#ededc3', "tour": "qsc", "color": "#081C3F" })
            // this.qscAll = qscAll
          } else {
            qscAll.push({ "code": this.qsc.code, "manyRounds": this.qsc.rounds, "daysAway": this.qsc.days_away, "name": this.qsc.full_name, "reports": this.url, "repName":  this.reportTitleElement, "repURL": this.reportURLLink, "num": 'Q-School', 'bkcolor': '#ededc3', "tour": "qsc", "color": "#081C3F" })
            this.qscAll = qscAll
          }
      });
    },
    // Get all tours data above
    getPolls() {
      axios
        .get(
          process.env.VUE_APP_APIFULL_URL +
            "tmticx?randomaddText=" +
            new Date().getTime()
        )
        .then(response => {
          this.Extradata = response.data;
          this.pollData = response.data.tm_params.polls;
          if (this.pollData != '') {
            this.showbutton = 'Y'
            if (Array.isArray(response.data.tm_params.polls.polls_entry)) {
              this.Extradata = response.data.tm_params.polls.polls_entry
            } else {
              console.log("is not Array");
              this.Extradata = [response.data.tm_params.polls.polls_entry];
            }
            // let arr = [];
            // console.log("this.arr")
            // console.log(arr)
            // this.Extradata.forEach((value, index) => {
            //     arr.push(value);
            //     console.log(value.source);
            //     console.log(index);
            // });
            this.pollsource = this.pollData.polls_entry.source;
            this.pollgeneral = this.pollData.polls_entry.general;
            this.pollMselect = this.pollData.polls_entry.multi_select;
            this.pollappImage = this.pollData.polls_entry.app_image;
            this.pollType = this.pollData.polls_entry.type;
            this.pollTypeLink = this.pollData.polls_entry.link_url;
            this.tourSelect = this.pollData.polls_entry.tours.tours_entry[0];
            console.log("this.tourSelect")
            console.log(this.tourSelect)
          } else {
            this.showbutton = 'N'
          }
        })
    },
    // Submiting Data for Polls when Anonymous is set to N
    sendPolls() {
      console.log('IN Send Polls')
      // MultiPolselected
      let voteCode = [];
      this.Extradata.forEach((value) => {
          voteCode.push(value.code);
      });
      this.voteCode = voteCode;
      this.selectedPol = this.Polselected + 1;
      let multiSeleted = []
      console.log("multiSeleted")
      console.log(multiSeleted)
      this.selectMulti = multiSeleted;

      this.MultiPolselected.forEach((value) => {
          multiSeleted.push(value);
      });

      if (this.pollMselect == 'Y') {
        console.log('MultiSelect')
				let sendpolls = '';

				sendpolls += 'alt' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				for (const i of this.selectMulti) {
					sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
        }
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
        return sendpolls 
      } else if(this.pollType == 'E') {
        console.log('Poll Type == E')
        let sendpolls = '';
        sendpolls += 'alt' + ' ';
        sendpolls += '.'  + ' ';
        sendpolls += '. W ';
        sendpolls += "'";
        sendpolls += "code|~" + this.voteCode + "<!/D>";
        sendpolls += 'option_1' + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      } else {
        console.log('NON MultiSelect')
        // let sendpolls = "let " + this.polEmail + '. W' + "'" + "fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "option_" + this.selectedPol + "|~Y<!/D>" + "fz|~" + this.fanZonejoin + "<!/D>" + "'"
        let sendpolls = '';

				sendpolls += 'alt' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      }
		},
    pollTypeEclick() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      console.log('Send Poll Data -- E')
      this.$socket.emit('vote', sktMsg);
      window.open(this.pollTypeLink, '_blank');
    }, 
    sendPollsData() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      // this.$socket.emit('vote', sktMsg);
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      this.thankyouMessage = 'Y' 
    },
    getTermsConditions: function() {
      axios
        .get(
          "https://ocs-cpt.com/apps/marketing-terms.php?action=latest&tour=" + 'cpt' + "&?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          // this.showTerms = 'Y';
          // console.log("this.showTerms")
          // console.log(this.showTerms)
          this.docTitle = this.base64Decode(response.data.documents.document.title);
          console.log("this.docTitle")
          console.log(this.docTitle)
          this.docContent = this.base64Decode(response.data.documents.document.content);
          console.log("this.docContent")
          console.log(this.docContent)
        });
    },
    // updateStuff() {
    //   console.log('update --')
    //       this.getqsctour();
    // }
  },
  created() {
    apiCall
      .tmParamsBase()
      .then(({ data }) => {
        try {
          this.getcp2tour();
          this.getcp3tour();
          this.getpamtour();
          this.getportour();
          this.getqsctour();
          this.getPolls();
          this.tm_params = data;
          const cptAll = []
          if (data.reports == '') {
            console.log('NoPush')
            // cptAll.push({ "code": this.tm_params.code, "name": this.tm_params.full_name, "reports": 'N', "num": 'Tier 1', 'bkcolor': '#00FFFE', "tour": "cpt", "color": "#081C3F" })
          } else {
            cptAll.push({ "code": this.tm_params.code, "manyRounds": this.tm_params.rounds, "daysAway": this.tm_params.days_away, "name": this.tm_params.full_name, "reports": this.tm_params.reports, "num": 'Tier 1', 'bkcolor': '#bceff0', "tour": "cpt", "color": "#081C3F" })          
          }

          this.cptAll = cptAll;
          if (data.use_full_name == 'N') {
            this.useName = data.short_name;
          } else {
            this.useName = data.full_name;
          }
          this.mobName = data.short_name
          this.course_name = data.course_name;
          this.courseDates = data.dates;
          this.live_scoring = data.live_scoring;
          this.Stableford = data.stableford;
          console.log("this.Stableford ")
          console.log(this.Stableford )
          this.DEFIMAGESAMS3 = data.tm_params.DEFIMAGESAMS3;
          if (Array.isArray(data.ad_files.ad_file_details)) {
            this.imagefiles = data.ad_files.ad_file_details
          } else {
            console.log("is not Array");
            this.imagefiles = [data.ad_files.ad_file_details]
          }
          this.roundsPLayed = data.rounds_played;
          if (data.reports == '') {
            this.reports = data.reports; 
            this.showcptreports = 'N'
          } else {
            this.reports = data.reports.reports_entry;
            this.showcptreports = 'Y'
          }
          if (data.days_away > -6 && data.days_away < 4) {
            this.cptshowTourn = true;
            console.log('in true')
          } else {
            this.cptshowTourn = false;
            console.log('in false')
          }
          this.season = data.tm_params.season_code;
          this.course = data.code;
          this.tourlogo = data.sponsor_logo;
          console.log("this.tourlogo")
          console.log(this.tourlogo)
          this.bkImage = data.course_image_file_1;
          this.imageCode = data.course_code;
          this.tournDates = data.dic_dates;
          this.loading = false;
          this.loadFirst = true;

          this.$nextTick(() => {
            this.setupLazyLoading();
          });

          setTimeout(() => {
            const loader = document.getElementById("loaderClass");

            if (loader) {
              loader.remove();
            }
          }, 500);
          // this.setTime = setTimeout(() => {
          //   this.loadPathwayIncentive = true,
          //   this.loadThird = true,
          //   this.loadFifth = true,
          //   this.loadYoutube = true
          //   this.loadSixth = true

          // }, 3000); 
          // setInterval(this.updateStuff, 30000);
        } catch (error) {
          // console.clear()
        }
      })
  },
  unmounted () {
  this.lazyObservers.forEach(observer => {
    observer.disconnect();
  });

  this.lazyObservers = [];
  }
};
</script>
<style scoped>
.youPad {
  padding: 3%;
}
.messageSec {
  /* margin-top: 60px; */
}
h2.loading {
  padding-top: 20px;
  font-weight: 600;
  font-size: 24px;
  color: #081C3F;
  text-align: center;
  /* padding-bottom: 90px; */
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #081C3F; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
  display: block;
}
.loaderSection {
  padding-top: 30px;
  padding-bottom: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.darkBkcolor {
  /* background-color: #081C3F; */
  /* padding-top: 2em;
  padding-bottom: 3em; */
  padding: 0%;
}
::v-deep .modal-footer {
  display: none!important;
}
span.titlesCol.perc {
    position: relative;
    left: 16px;
    font-weight: bold;
}
span.titlesCol.votes {
    position: relative;
    left: -11px;
}
span.titlesCol {
    font-weight: 600;
    text-align: center;
    margin: auto;
}
.col-lg-8.nameWidth {
    flex: 0 0 80%;
    max-width: 80%;
}
.col-6.nameWidth {
    flex: 0 0 70%;
    max-width: 70%;
}
.percent {
  position: absolute;
  right: -80px;
  top: 0px;
}
@media (min-width: 1200px) {
  .modal-dialog.modal-xl {
    max-width: 1350px!important;
  }
}
.votePlayerofMonth {
    margin-top: 40px;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 30px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  /* position: absolute; */
  right: 14em;
  margin-top: 0px;
  width: 100%;
  height: 50px;
  margin-bottom: 90px;
  background-color: #1C2335;
  border-color: #1C2335;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
::v-deep div#posts {
  /* margin-top: 30px; */
  margin-top: 5px;
}
div#slider {
  /* padding-bottom: 80px; */
}
.oonSliderBk {
  background-color: #fff;
  /* height: 500px; */
}
.shapGolf {
  background-color: #081C3F;
}
#twitter {
  padding-top: 50px;
}
#social {
  padding: 2%;
}
#posts {
  padding: 3%;
  padding-top: 0%;
}
.sponsor {
  max-width: 250px;
  /* max-width: 136px; */
  vertical-align: middle;
  margin-right: auto;
  /* margin-bottom: 10px; */
  margin-bottom: 25px;
  margin-top: -135px !important;
  margin-left: 10% !important;
}
.liveScoreMsg {
  position: fixed;
  bottom: 0px;
  z-index: 10000;
  min-height: 80px;
  width: 100%;
  padding: 15px;
  background-color: #081C3F;
  text-align: center;
}
.liveMsg {
  text-align: center;
  color: #ffffff;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  font-size: 24px;
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0px;
    margin-right: 0px;
  }
}
@media only screen and (max-width: 1200px) {
  .darkBkcolor{
    margin-top: 1em;
  }
}
@media only screen and (max-width: 990px) {
  .sponsor {
    display: none;
  }
  div#slider {
    padding-bottom: 45px;
    /* margin-top: 30em; */
    margin-top: 0em;
    /* display: inline-block; */
  }
  ::v-deep .homeCont {
    padding-left: 0px;
    padding-right: 0px;
  }
  ::v-deep div#posts {
    margin-top: 0px;
  }
  .youPad{
    padding: 0%;
  }
}
@media only screen and (max-width: 768px) {
  span.titlesCol.perc {
    position: relative;
    left: 0!important;
    font-weight: 700;
  }
  .extraPadTop {
    padding-top: 0px;
    padding-bottom: 20px;
  }
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
}
@media only screen and (max-width: 510px) {
  .messageSec {
    margin-top: 0px;
  }
  div#slider {
    padding-bottom: 0px;
    /* margin-top: 30em; */
    margin-top: 0em;
    /* display: inline-block; */
  }
}
@media only screen and (max-width: 480px) {
  .mobileSpace {
    margin-top: 50px;
  }
  #twitter {
    flex-basis: auto;
    padding-top: 0px;
  }
  #reports {
    flex-basis: auto;
  }
  #rt {
    flex-basis: auto;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
</style>